import Lookup from './lookup.js';

export default class LevelOne extends Lookup
{
    
}
